/**
 * Функция для создания слежки за изменениями элемента
 * 
 * @param {Function} callback - калбэк функция вызываемая по указаным изменениям, по дефолту вызывается при изменении потомков
 * @param {MutationObserverInit} options - параметры MutationObserver, default { childList: true }
 * @returns 
 */

const createContentObserver = (callback, options = {}) => {
    const defaultOptions = {
        childList: true,                // отслеживать добавление/удаление дочерних элементов
        subtree: false,                 // отслеживать во всех потомках
        characterData: false,           // отслеживать изменения текста
        characterDataOldValue: false,   // сохранять старое значение
        attributes: false,              // отслеживать изменения атрибутов
        attributeOldValue: false        // сохранять старое значение аттрибутов
    };

    const config = { ...defaultOptions, ...options };

    const observer = new MutationObserver((mutationsList) => {
        callback(mutationsList, observer);
    });

    return {
        observe: (target) => observer.observe(target, config),
        disconnect: () => observer.disconnect(),
    }
}

export default createContentObserver;
